import { useState, useEffect } from "react";

function getWindowDimensions() {
  //   const { innerWidth: width, innerHeight: height } = window;
  const width = window.screen.width;
  const height = window.screen.height;
  return {
    width,
    height,
  };
}

export default function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}
